/* eslint-disable import/no-extraneous-dependencies */
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { useNavigate, useParams } from "react-router-dom";
import { EventDetails } from "components/EventDetails";
import Background from "assets/badges/background.jpg";
import { Header } from "components/Common/Header";
import { useEvent } from "hooks/useEvent";
import Text from "components/Common/Text";
import { QRCodeSVG } from "qrcode.react";
import { useAuth } from "hooks/useAuth";

// eslint-disable-next-line import/no-extraneous-dependencies

// eslint-disable-next-line import/no-extraneous-dependencies

export default function ShareScreen() {
  const navigate = useNavigate();

  const { eventId } = useParams();
  const event = useEvent(eventId);
  const { user } = useAuth();

  const { date, courseName, createdBy } = event ?? {};

  const { lastName, firstName, profileImageUrl } = createdBy ?? {};

  const prefix = {
    DEV: "develop-",
    SRAGING: "staging-",
    PROPD: null,
  };

  return (
    <>
      <Header event={event} userData={user} showTitle hideQr />
      <div
        style={{
          flex: 1,
          height: "100%",
          backgroundImage: `url(${Background})`,
          backgroundPosition: "right",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#2977A4",
          backgroundBlendMode: "soft-light",
          zIndex: 0,
        }}
      >
        <Text as="H2" bold ta="center" mt={16}>
          Scan to join PINZ teams match!
        </Text>
        {!event ? (
          <ActivityIndicator />
        ) : (
          <>
            <div
              onClick={() => navigate(`/event/${eventId}`)}
              aria-hidden
              style={{
                backgroundColor: "#1B4F6D",
                borderRadius: 16,
                display: "flex",
                flexDirection: "row",
                padding: "20px 16px",
                margin: "12px 20px",
                justifyContent: "space-between",
              }}
            >
              <EventDetails
                timestamp={date}
                courseName={courseName}
                profileImageUrl={profileImageUrl}
                firstName={firstName}
                lastName={lastName}
                share
              />
            </div>
            <div
              style={{
                padding: 20,
                backgroundColor: "white",
                alignSelf: "center",
                marginTop: 20,
                border: " 10px solid #41EE67",
                borderRadius: 40,
              }}
            >
              <QRCodeSVG
                value={`https://${
                  prefix[process.env.REACT_APP_TEST]
                }pinz-lite.web.app/invitation/${eventId}`}
                size={200}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
}
